var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "M12.6 0h-7c-.772 0-1.4.628-1.4 1.4v2.8H1.4C.628 4.2 0 4.828 0 5.6v7c0 .772.628 1.4 1.4 1.4h7c.772 0 1.4-.628 1.4-1.4V9.8h2.8c.772 0 1.4-.628 1.4-1.4v-7c0-.772-.628-1.4-1.4-1.4M1.4 12.6v-7h7l.001 7zm11.2-4.2H9.8V5.6c0-.772-.628-1.4-1.4-1.4H5.6V1.4h7z"
})));
export { SvgCopy as ReactComponent };
export default __webpack_public_path__ + "Copy.23667267.svg";